import { gql } from "apollo-boost";

export const GET_APP_DOCUMENTS = gql`
    query GetAppDocuments($first: Int, $page: Int) {
        documents(
            first: $first
            page: $page
            where: {
                AND: [
                    { column: PLACEMENT, operator: EQ, value: "additional_menu" }
                    { column: ACTIVE, operator: EQ, value: true }
                ]
            }
            orderBy: [{ column: ROW_ORDER, order: ASC }, { column: ID, order: ASC }]
        ) {
            paginatorInfo {
                currentPage
                lastPage
                total
                hasMorePages
            }
            data {
                id
                title
                getFileUrl
                active
                placement
                row_order
            }
        }
    }
`;
